module.exports = __webpack_public_path__ + "img/step43.9495cf80.png";